module.exports = __webpack_public_path__ + "img/asc_icon.2d121a93.svg";